import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
// TODO unit test me please…!
@Injectable({
    providedIn: 'root'
})
export class ConnectionMonitorService implements OnDestroy {
    LOG_SOURCE = 'ConnectionMonitorService';

    public online$: Observable<boolean>;
    private readonly onlineSubject = new Subject<boolean>();
    private readonly subscriptions = new Subscription();

    public constructor() {
        this.online$ = this.onlineSubject.asObservable();
        fromEvent(window, 'online').subscribe(() => this.onlineSubject.next(true));
        fromEvent(window, 'offline').subscribe(() => this.onlineSubject.next(false));
    }

    public ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
